/* globals dataLayer, angular */
(function (window, angular, undefined) {
    angular.module('formApp')
        .component('coverSummary', {
            templateUrl: 'components/cover-summary/templates/cover-summary.html',
            bindings: {
                formData: '<',
                eQuote: '<',
                eCoverNote: '<',
                freeCoverExpired: '<',
                coverNoteEnd: '<',
                c4lTitle: '@',
                essentialTitle: '@',
                rabbitTitle: '@'
            },
            controller: ['dataUtils', '$filter', '$rootScope','$scope', function (dataUtils, $filter, rootScope,$scope) {

                dataUtils.getIpids();

                var ctrl = this;
                ctrl.isEcover = sessionStorage.getItem('eCoverNote') === 'true';
                ctrl.isEquote = sessionStorage.getItem('eQuote') === 'true';

                ctrl.combined = sessionStorage.getItem('journeyType') === 'combined' || sessionStorage.getItem('journeyType') === 'combined2';
                ctrl.hideEditLink = false;

                ctrl.getProductTitle = dataUtils.getProductTitle;
                ctrl.getProductPlan = dataUtils.getProductPlan;
                ctrl.getIpid = dataUtils.getIpid;

                if (sessionStorage.getItem('retrieveQuote') === 'true') {
                    ctrl.hideEditLink = true;
                }

                ctrl.$doCheck = function () {
                    // something...
                };

                ctrl.getCover = function (pet) {
                    return pet && pet.chosenCover ? pet.chosenCover.productLine.toUpperCase() : '';
                };

                ctrl.getParisBreed = function (pet) {
                    var breed = '';
                    angular.forEach(ctrl.formData.products, function (prod) {
                        if (pet.chosenCover && pet.chosenCover.productId === prod.id && pet.uri === prod.pet) {

                            if (prod.parisBreedTwo !== 'Unknown' && pet.details.type === 'MultiBreed' && pet.type === 'dog') {
                                breed = prod.parisBreed + ' and ' + prod.parisBreedTwo + ' cross';
                            }
                            else if (prod.parisBreedTwo === 'Unknown' && pet.details.type === 'MultiBreed' && pet.type === 'dog') {
                                breed = prod.parisBreed + ' cross';
                            }
                            else {
                                breed = prod.parisBreed;
                            }

                        }
                    });
                    return breed;
                };

                ctrl.noToAllQuestions = function (pet) {
                    var officeUseOnlyParams = ctrl.formData.officeUseOnlyParams;
                    var charityCodes = ['CY', 'CP', 'BX', 'NC'];
                    var breederCodes = ['PK'];
                    var isCharity = officeUseOnlyParams && charityCodes.includes(officeUseOnlyParams.prodId);
                    var isBreeder = officeUseOnlyParams && breederCodes.includes(officeUseOnlyParams.prodId);
                    var charityNotVoucher = isCharity && officeUseOnlyParams.voucher === 'false';
                    var isVet = officeUseOnlyParams && officeUseOnlyParams.prodId === 'IV' && officeUseOnlyParams.partnerType === 'VETS';
                    //var isChipper = officeUseOnlyParams && officeUseOnlyParams.prodId === 'IV' && officeUseOnlyParams.partnerType === 'CHIPPERS';
                    if ((ctrl.isEcover || ctrl.isEquote) && (isCharity && charityNotVoucher || isBreeder)){
                        return pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'N' && pet.extraQuestions.petHealthHistoryDocument === 'N';
                    }
                    if ((ctrl.isEcover || ctrl.isEquote) && isVet ) {
                        return pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'N' && pet.extraQuestions.everSeenByVet === "N";
                    }
                    return pet.extraQuestions && pet.extraQuestions.beenInsuredBefore === "N" && ( pet.extraQuestions.everSeenByVet === "N" || pet.extraQuestions.everSeenByVet === "Y" && pet.extraQuestions.everSeenByVetInnocous === "Y" ) && pet.extraQuestions.signsOfIllnessOrInjuryUwq === 'N' && pet.extraQuestions.insuranceDeclinedBefore === 'N';
                };

                ctrl.getVetFeeExcess = function (pet) {
                    var product,
                        cover;
                    if (ctrl.formData.products) {
                        product = ctrl.formData.products.filter( function(p) {
                            return p.id === pet.chosenCover.productId;
                        });
                        cover = product[0].covers.filter ( function(c) {
                            return c.sectionId === 'VFB';
                        });
                        if (cover) {
                            return $filter('currency')(cover[0].sectionLimit, "£", 0);
                        } else {
                            return '';
                        }
                    } else {
                        return '';
                    }
                };

            }]
        });
})(window, window.angular);